export default {
  LOGIN: '/brand/v1/session',
  PRESHOWS: '/brand/v1/preshows',
  BUDGET: '/brand/v1/budget',
  SPOT: '/brand/v1/spots',
  SURVEY_RESULTS: '/brand/v1/survey_results',
  CHANGE_PASSWORD: '/brand/v1/password_change'
};
